import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { MutationStatus } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_DELETE_TENANT_ACCOUNT = gql`
  mutation deleteTenantAccount {
    deleteTenantAccount {
      code
      message
      error
    }
  }
`;

export const mutationDeleteTenantAccount = async (
  client: ApolloClient<NormalizedCacheObject>,
  tenantId: string,
): Promise<MutationStatus | undefined> => {
  const baseHeaders = await getStandardHeaders(true);
  // The tenant to delete is identified by the x-aptean-tenant header (aptean-admin only).
  const headers = { ...baseHeaders, 'x-aptean-tenant': tenantId };
  const { data, errors } = await client.mutate<{ deleteTenantAccount: MutationStatus }>({
    mutation: MUTATION_DELETE_TENANT_ACCOUNT,
    context: { headers },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the tenant delete.');
  }

  return data?.deleteTenantAccount;
};
